import { useState, useEffect } from 'react';
import { DataServiceHookResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { useInvokeSWRService } from '@dxb-web-ui-framework/common/hooks';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { useExecuteBulkMandatesService } from '../../../contexts';

const useMandateBulkExecuteService = (
  successCallback: () => void,
  requestId?: Nullable<string>,
): DataServiceHookResponse<{}> => {
  const [timestamp, setTimestamp] = useState<Nullable<string>>(null);
  const executeMandateService = useExecuteBulkMandatesService()();

  const shouldExecuteAuthorization = Boolean(requestId) && Boolean(timestamp);

  useEffect(() => {
    if (!timestamp) {
      setTimestamp(new Date().toISOString());
    }
  }, [timestamp]);

  // Initiate Authorization
  return useInvokeSWRService<{}>(
    executeMandateService,
    {
      requestId,
      successCallback,
      meta: { timestamp },
    },
    shouldExecuteAuthorization,
    'authorizationService.ExecuteMandate',
  );
};

export { useMandateBulkExecuteService };
